import './SeparateStatusTrend.css';

import React from 'react';
import { StatusIcon, TrendIcon } from '../helper';
import { generateClassName } from '../../../b2b-common/helpers';

const SeparateStatusTrend = ({ status, trend,
    showStatus = true, showTrend = true,
    className = null, locale = null }) => {
    return (
        <div className={generateClassName('separate-status-and-trend', '', className)}>
            {showStatus && (
                <div className='separate-status'>
                    <StatusIcon status={status} locale={locale} />
                </div>
            )}
            {showTrend && (
                <div className='separate-trend'>
                    <TrendIcon trend={trend} locale={locale} />
                </div>
            )}
        </div>
    )
}

export default SeparateStatusTrend;